import React from "react";
import { useTranslation } from "react-i18next";

const SelectField = React.forwardRef(
  (
    {
      label,
      value,
      onChange,
      options,
      error,
      placeholder,
      required = false,
      disabled = false,
    },
    ref
  ) => {
    const { t } = useTranslation();
    return (
      <div className="w-full">
        <label className="block text-sm font-medium text-ui-text mb-2">
          {label} {required && <span className="text-state-danger">*</span>}
        </label>
        <select
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full h-12 px-4 border rounded-lg bg-ui-surface text-ui-text focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all duration-200 ${
            error ? "border-state-danger" : "border-ui-border"
          } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
          ref={ref}
        >
          <option value="">{placeholder ?? t("fields.selectOption")}</option>
          {options.map((option, index) => (
            <option key={index} value={option.value || option}>
              {option.label || option}
            </option>
          ))}
        </select>
        {error && <p className="text-state-danger text-sm mt-1">{error}</p>}
      </div>
    );
  }
);

export default SelectField;
